import { type ForwardedRef, forwardRef } from 'react';

import { EmployeeGender } from '@/common/graphql';
import { ObjectUtils } from '@/common/utils';

import type { ComboboxItemWithFormatted } from '../props';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

interface GenderSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<EmployeeGender>>, 'searchable' | 'value'> {
  value: EmployeeGender | null;
}

export const EmployeeGenderLabels: Record<EmployeeGender, string> = {
  [EmployeeGender.Female]: 'Female',
  [EmployeeGender.Male]: 'Male',
  [EmployeeGender.Other]: 'Other',
};

const data = ObjectUtils.arrayFromEnumValues<EmployeeGender>(EmployeeGender).map(value => ({
  label: EmployeeGenderLabels[value],
  value,
}));

export const GenderSelectSingle = forwardRef(
  ({ placeholder = 'Select Gender', ...rest }: GenderSelectSingleProps, ref: ForwardedRef<HTMLDivElement>) => (
    <SelectSingle ref={ref} {...rest} data={data} loading={false} placeholder={placeholder} searchable={false} />
  ),
);
